import { useHistory } from "react-router-dom";
import { GridRowParams } from "@mui/x-data-grid-pro";

import { COLLECTION_YARDS_PAGE_PATH } from "../../../middleware/routes";
import { COLLECTION_POINT_VISIT_PAGE_PATH } from "../../../middleware/routes";
import { PREV_PAGE_PARAM } from "../../../utils/url";

export const useGetCollectionYardsTableHandlers = () => {
  const history = useHistory();

  const handleAdditionalRowClick = (params: GridRowParams<any>): void => {
    const visitId = params.row.visitId;
    const locationId = params.row.locationId;
    const prevPage = COLLECTION_YARDS_PAGE_PATH;

    const urlParams = new URLSearchParams();
    urlParams.set("id", String(locationId));
    urlParams.set("cyvid", String(visitId));
    urlParams.set(PREV_PAGE_PARAM, prevPage);

    history.push(`${COLLECTION_POINT_VISIT_PAGE_PATH}?${urlParams.toString()}`);
  };

  return { handleAdditionalRowClick };
};
